///// <reference path="../../typings/react/react-global.d.ts" />
///// <reference path="../../typings/jquery/jquery.d.ts" />

import * as React from "react";
import * as $ from 'jquery';

import Navigation from './Navigation';
import MainPage from './MainPage';
import {IApplicationStoreState, applicationStore} from '../stores/ApplicationStore'
import {ActionCreator} from '../actions/ActionCreator';

import Modal from './Helpers/Modal'

export interface IApplicationState extends IApplicationStoreState {
    isCommunicationActive?: boolean
}

export default class Application extends React.Component<any, IApplicationState> {

    constructor() {
        super();

        this.state = Object.assign({}, applicationStore.getState(), {
            isCommunicationActive: true
        });
        
        this.onChange = this.onChange.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
        this.close = this.close.bind(this);
        this.yesClick = this.yesClick.bind(this);
        this.noClick = this.noClick.bind(this);
    }   

    close() {
        ActionCreator.closeModal();
    }
    
    onTabChange(isCommunicationActive: boolean) {
        var newState = $.extend({}, this.state, {isCommunicationActive: isCommunicationActive});
        this.setState(newState);
    }
    
    componentDidMount() {
        applicationStore.addChangeListener(this.onChange);
    }

    componentWillUnmount() {
        applicationStore.removeChangeListener(this.onChange);
    }
    
    onChange() {
        var newState = $.extend(applicationStore.getState(), {isCommunicationActive: this.state.isCommunicationActive});
        this.setState(newState);
    }
    
    yesClick() {
        ActionCreator.createMerchantTermianlFolders(this.state.merchantId, this.state.terminalId);
        ActionCreator.closeYesNoModal();
    }
    
    noClick() {
        ActionCreator.closeYesNoModal();
    }

    render() {
        return (
            <div>
                <Navigation isCommunicationActive={this.state.isCommunicationActive} 
                            onTabChange={this.onTabChange} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12 col-md-12">
                            <MainPage isCommunicationActive={this.state.isCommunicationActive} />
                            </div>
                        </div>
                    </div>
                <footer className="footer">
                    <div className="container">
                        <div className="row vertical-align copyright">
                            <div className="col-sm-12" >
                                <p style={{ margin: "0px" }}>{'\u00A9'} 2016 NCR GiftCard Processor Stub</p>
                            </div>
                        </div>
                    </div>
                </footer>
                <Modal show={this.state.isModalDialogShown} onClose={this.close.bind(this)} closeOnOuterClick={true}>
                      <div style={{color: 'red', fontSize: '20px'}}>
                        <strong>{this.state.modalDialogMessage}</strong>
                      </div>
                </Modal>
                <Modal show={this.state.isYesNoModalDialogShown}>
                    <form>
                        <div className="form-group">
                            <div dangerouslySetInnerHTML={{__html: this.state.yesNoModalDialogMessage}} />
                        </div>
                        <div className="form-group">
                            <button type="button" className="btn btn-primary" style={{marginRight: "10px"}} onClick={this.yesClick}>Yes</button>
                            <button type="button" className="btn btn-default" onClick={this.noClick}>No</button>
                        </div>
                    </form>                
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/Application.tsx